import { render, staticRenderFns } from "./GreenOperationPreviewSendModal.vue?vue&type=template&id=1019d263&scoped=true&"
import script from "./GreenOperationPreviewSendModal.vue?vue&type=script&lang=js&"
export * from "./GreenOperationPreviewSendModal.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationPreviewSendModal.vue?vue&type=style&index=0&id=1019d263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019d263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1019d263')) {
      api.createRecord('1019d263', component.options)
    } else {
      api.reload('1019d263', component.options)
    }
    module.hot.accept("./GreenOperationPreviewSendModal.vue?vue&type=template&id=1019d263&scoped=true&", function () {
      api.rerender('1019d263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/letters/GreenOperationPreviewSendModal.vue"
export default component.exports